import { EventBus } from 'primevue/utils';

var ToastEventBus = EventBus();

export default ToastEventBus;
